import { Outlet } from 'react-router-dom';

import { ROUTES } from '../constants/routes';

import DashboardLayout from '@layouts/dashboardLayout/Dashboard.layout';
import CustomerDeliveryFilesViewPage from 'pages/customer-delivery-files/customer-delivery-files-view';
import CustomerDeliveryFileRegisterPage from 'pages/customer-delivery-files/customer-delivery-file-register';
import CustomerDeliveryFileUpdatePage from 'pages/customer-delivery-files/customer-delivery-file-update';
import WithAuth from 'shared/components/hocs/with-auth';

export const CUSTOMER_DELIVERY_FILES_ROUTES = {
  path: '',
  element: (
    <WithAuth>
      <Outlet />
    </WithAuth>
  ),
  children: [
    {
      path: ROUTES.CUSTOMER_DELIVERY_FILES.ROOT,
      element: (
        <DashboardLayout>
          <CustomerDeliveryFilesViewPage />
        </DashboardLayout>
      ),
    },
    {
      path: ROUTES.CUSTOMER_DELIVERY_FILES.REGISTER_FILE.path,
      element: (
        <DashboardLayout>
          <CustomerDeliveryFileRegisterPage />
        </DashboardLayout>
      ),
    },

    {
      path: `${ROUTES.CUSTOMER_DELIVERY_FILES.UPDATE_FILE.path}/:fileId`,
      element: (
        <DashboardLayout>
          <CustomerDeliveryFileUpdatePage />
        </DashboardLayout>
      ),
    },
  ],
};
